import { NgModule,CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import { CommonModule } from '@angular/common';
import { JourneyComponent } from './journey/journey.component';
import { TeamComponent } from './team/team.component';
import { RecognitionComponent } from './recognition/recognition.component';
import { CorporateGivingComponent } from './corporate-giving/corporate-giving.component';
import * as AOS from 'aos';
import Swiper from 'swiper'; 

import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { register } from 'swiper/element';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { AboutRoutingModule } from './about-routing.module';
import {MatIconModule} from '@angular/material/icon'
import { TimeLineComponent } from './time-line/time-line.component';
import { ProfileComponent } from './profile/profile.component';
import { CapabilityStatementComponent } from './capability-statement/capability-statement.component';

register();


@NgModule({
  declarations: [
    JourneyComponent,
    TeamComponent,
    TimeLineComponent,
    RecognitionComponent,
    CorporateGivingComponent,
    ProfileComponent,  
    CapabilityStatementComponent


  ],schemas:[CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    // SlickCarouselModule,
     BrowserModule,BrowserAnimationsModule,CarouselModule,AboutRoutingModule,
    MatIconModule
  ]
})
export class AboutModule { }
